// import Splide from '@splidejs/splide';

// // Import our default css theme for splide
// import '@splidejs/splide/css';

// This should only be output on the frontend of the site - NOT the editor

document.addEventListener( 'DOMContentLoaded', () => {

//   // Splide
//   const splidePosts = document.querySelectorAll('.splidePosts')

//   if(!!splidePosts && splidePosts.length > 0){
//     splidePosts.forEach(splidePosts => {

//       // Grab the slide interval and convert it to an integer and milliseconds
//       const interval = parseInt(splidePosts.dataset.interval) * 1000 || 3000
//       new Splide(splidePosts, { pagination: false, perMove: 1, height:'650px', pauseOnHover: false, interval: interval,
// // marginLeft:'2em',
// // gap    : '2rem',
//   breakpoints: {
//     6000: {
//       perPage: 2,
//       gap    : '2rem',
//       height:'750px',

//     },

//     2000: {
//       perPage: 2,
//       gap    : '2rem',

//       height:'650px',
//     },

//     1200: {
//       perPage: 1,
//       gap    : '2rem',

//       height:'650px',
//     },

//     960: {
//       perPage: 1,
//       gap    : '.7rem',
//       height:'650px',

//     },
//     720: {
//       perPage: 1,
//       height:'fit-content',
//       gap    : '0.7rem',


//       //gap    : '8rem',

//     }
//   },


//       }).mount()
//     })
//   }
})